module.exports = __webpack_public_path__ + "static/media/CD.eaf9c224.svg";